<template>
  <!--srcviewshomeindexvuehtmlStart-->
  <div id="defaultId1 ">
    <!-- 轮播图背景 -->
    <div id="g58c05" class="u3e56f">
      <!-- ndicator-position="outside"-->
      <!-- <el-carousel id="c9fefa" height="100%" arrow="never" :interval="60000" :autoplay="true" i>
        <el-carousel-item v-for="(item, index) in items" :key="index" @before-enter="beforeEnter" @leave="leave">
        
        </el-carousel-item>


      </el-carousel> -->
      <div class="u090a2 el-carousel__item">
        <div class="u070db  active" :class="this.$route.query.Detail == 'Trade' ? 'u070db_3' : 'u070db_4'"></div>

      </div>
    </div>
    <div>


    </div>
    <!-- 头部 -->

    <Hearder></Hearder>
    <!-- 搜索模块 -->
    <div id="gcd363" class="u63509">

      <!-- 贸易 -->
      <div id="g28c69" v-if="this.$route.query.Detail == 'Trade'" class="u11f46">
        <div id="gc1d8d" class="u5faed Tradeu5faed">

          <div id="g3a94b" class="u0a08d">

            <el-autocomplete id="c308fb" clearable v-model="searchStr" style="width: 100%;height: auto;"
              :highlight-first-item="true" ref="TradeInput" :debounce="300" :trigger-on-focus="false" :autofocus="true" class="u0fcfc"
              @select="handleSelect" :fetch-suggestions="querySearchAsync" :placeholder="placeholderTrade" size="large">
              <el-select v-model="tradeSelect" slot="prepend" placeholder="Please Select" @change="SelectTrade">
                <el-option label=" Product" value="HsCode"></el-option>
                <el-option label=" Company" value="Company"></el-option>
                <el-option label="Country" value="Country"></el-option>
              </el-select>

            </el-autocomplete>
          </div>

          <div id="g578ea" class="u4a33a" :class="this.$route.query.Detail == 'Trade' ? 'NewsBack' : 'RiskBack'">
            <svg id="cce44c" class="icon" t="1718861469940" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="5185" width="3em" height="3em">
              <path id="c30532"
                d="M863.38 825.09L714.17 675.88c48.01-57.12 74.18-128.58 74.18-204.08 0-84.89-33.06-164.7-93.08-224.72C635.24 187.05 555.44 154 470.55 154c-84.89 0-164.7 33.06-224.72 93.08s-93.08 139.83-93.08 224.72 33.06 164.7 93.08 224.72 139.83 93.08 224.72 93.08c76.22 0 148.33-26.67 205.72-75.56l149.08 149.08a26.805 26.805 0 0 0 19.01 7.88c6.88 0 13.76-2.63 19.01-7.88a26.805 26.805 0 0 0 7.88-19.01c0-6.89-2.62-13.77-7.87-19.02zM206.53 471.8c0-145.58 118.44-264.02 264.02-264.02 145.58 0 264.02 118.44 264.02 264.02S616.13 735.82 470.55 735.82c-145.58 0-264.02-118.44-264.02-264.02z"
                fill="#FFF" p-id="5186"></path>

            </svg>
            <span>
              Search

            </span>
          </div>
        </div>
      </div>
      <div v-else id="g28c69" class="u11f46">

        <div id="gc1d8d" class="u5faed">
          <div class="search_left" :class="countryImg ? 'on' : ''">
            <div class="country_flag">
              <img :class="countryImg ? 'country_flag_img' : 'none'" :src="countryImg" />
            </div>
            <el-select v-model="countryCode" ref="select" clearable @clear="clearCountry"
              :placeholder="$t('Home.selectCountry')" popper-class="sel_box sel_boxhome sel_Contry"
              @change="selectCountry" no-match-text="No data" no-data-text="No data">
              <div class="search_sel_container">
                <el-tabs tab-position="left" v-model="tabActiveName">
                  <el-tab-pane v-for="(tab, index) in tabCountryList" :key="index">
                    <div slot="label" class="flex_center_between_box">
                      <span class="left_txt">{{ tab.continent.enName }}</span>
                      <span class="right_txt">{{
                        tab.continent.countryNumStr
                        }}</span>
                    </div>
                    <div class="right">
                      <el-option v-for="item in tab.countryList" :key="item.id" :value="item.countryCode"
                        v-show="item.companyNum > 100" :label="item.nameEn" @click.native="labelClick(item.label)">
                        <div class="right_item flex_box">
                          <div class="img flex_center">
                            <img :src="item.urlBanner" />
                          </div>

                          <div class="rBox">
                            <div class="coun_title">{{ item.nameEn }}</div>
                            <div class="coun_num">{{ item.companyNumStr }}</div>
                          </div>
                        </div>
                      </el-option>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </el-select>
          </div>

          <div id="g3a94b" class="u0a08d">
            <el-input id="c308fb" v-model="searchStr" class="u0fcfc" @keydown.native="(e) => { if (e.key === 'Enter' && !e.isComposing) openList(searchStr) }"
              :placeholder="$t('Home.inputCompany')" size="large">
            </el-input>
          </div>
          <div class="head_swi_keyword ">
            <el-switch v-model="Keyword" active-color="#1290C9 " inactive-color="#1290C9"
              @change="switchHeadKeyword"></el-switch>
            <span v-if="Keyword == true" class="switch_txt">{{ $t('Home.keWord') }}</span>
            <span v-else class="switch_txt">{{ $t('Home.firstWord') }}</span>
          </div>

          <div id="g578ea" @click="openList(searchStr)" class="u4a33a">
            <svg id="cce44c" class="icon" t="1718861469940" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="5185" width="3em" height="3em">
              <path id="c30532"
                d="M863.38 825.09L714.17 675.88c48.01-57.12 74.18-128.58 74.18-204.08 0-84.89-33.06-164.7-93.08-224.72C635.24 187.05 555.44 154 470.55 154c-84.89 0-164.7 33.06-224.72 93.08s-93.08 139.83-93.08 224.72 33.06 164.7 93.08 224.72 139.83 93.08 224.72 93.08c76.22 0 148.33-26.67 205.72-75.56l149.08 149.08a26.805 26.805 0 0 0 19.01 7.88c6.88 0 13.76-2.63 19.01-7.88a26.805 26.805 0 0 0 7.88-19.01c0-6.89-2.62-13.77-7.87-19.02zM206.53 471.8c0-145.58 118.44-264.02 264.02-264.02 145.58 0 264.02 118.44 264.02 264.02S616.13 735.82 470.55 735.82c-145.58 0-264.02-118.44-264.02-264.02z"
                fill="#FFF" p-id="5186"></path>
            </svg>
            <span>
              {{ $t('Home.search') }}

            </span>

          </div>
        </div>
      </div>
      <div class="Seach_text" v-if="this.$route.query.Detail == 'Trade'">
        Transform global trade data into strategic market insights
      </div>
      <div class="Seach_text" v-else>
        {{ $t('Home.searchCompanyNum') }}
      </div>
      <!-- 新闻推荐 -->
      <div id="gcb648" class="ubb80e">
        <div class="old-new" style="display: none;">
          <div id="gc5779" class="u1df9f">
            <div id="gca8a4" class="u2772e">{{ $t('Home.homeSeachTitle') }}</div>

          </div>
          <div id="g75f5a" class="u9a1a8">
            <div id="gec133" class="ued8bb">
              <div id="g88036" class="u807e8">
                <div id="gb6e12" @click="taggleFlolwing('explore')" :class="followingName == 'explore' ? 'active' : ''"
                  class="u476e8">
                  Explore
                </div>
                <div id="g14cf0" @click="taggleFlolwing('Following')"
                  :class="followingName == 'Following' ? 'active' : ''" class="u6eb8b">
                  Following
                </div>
              </div>
              <div id="gca424">
                <el-dropdown id="c1952f" class="u994i9a">
                  <div id="c4b805" class="el-dropdown-link u807e8 home_news_down">
                    <div id="c310af" class="uUgrpts select_tab unrH9VJ" myData="测试">
                      International
                    </div>
                    <svg id="c726d4" class="icon" t="1716884069110" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="4620" width="14" height="14">
                      <path id="c1aa32"
                        d="M512 730c-6.4 0-12.8-2.4-17.7-7.3l-386-386c-9.8-9.8-9.8-25.6 0-35.4 9.8-9.8 25.6-9.8 35.4 0L512 669.6l368.3-368.3c9.8-9.8 25.6-9.8 35.4 0 9.8 9.8 9.8 25.6 0 35.4l-386 386c-4.9 4.9-11.3 7.3-17.7 7.3z"
                        fill="#333333" p-id="4621"></path>
                    </svg>
                  </div>
                  <div id="c31608" slot="dropdown">
                    <el-dropdown-menu id="c9885b" class="uWDPJiJ">
                      <el-dropdown-item id="c71a54" v-for="(item, index) in favoritesList" :key="index">
                        <div id="c73ebf" @click="activeFavoritesId = item.id" class="u606de">
                          <div id="c7d5e8" class="u7fb7a">
                            <svg id="c5768a" class="icon" v-if="activeFavoritesId == item.id" t="1718777785755"
                              viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4867"
                              width="16" height="16">
                              <path id="cb3514" :class="activeFavoritesId == item.id ? 'active' : ''
                                "
                                d="M939.36 218.912a32 32 0 0 1 45.856 44.672l-538.016 552a32 32 0 0 1-43.776 1.92L63.872 526.048a32 32 0 1 1 41.696-48.544l316.768 271.936L939.36 218.88z"
                                fill="#1A2332" p-id="4868"></path>
                            </svg>
                          </div>
                          <div id="cf0a50" :class="activeFavoritesId == item.id ? 'active' : ''" class="ucc8d2">
                            {{ item.name }}
                          </div>
                        </div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </div>
                </el-dropdown>
              </div>
            </div>
            <div id="g4424c" class="u75237">
              <div id="gea9ef" class="u5efe2">
                <!-- <img id="g78166" class="u326e0" src="../../assets/images/home_new_center.png" alt="" /> -->
                <div class="botton_left_text">
                  <img id="g78166" class="shuidi" style="height: 16px;width: 22px;"
                    src="../../assets/images/tuoyuan.png" alt="" />
                  <div class="text-carousel" @click="gotccsibizinfo('https://www.csibizinfo.com/?Form=Csi')">

                    <!--  @slideChange="onSlideChange" -->
                    <swiper :options="swiperOption" class="swiper-container">
                      <swiper-slide>{{ $t('Home.BusinessIntelligence') }} </swiper-slide>
                      <swiper-slide>{{ $t('Home.CompanyIdentityVerification') }} </swiper-slide>
                      <swiper-slide>{{ $t('Home.KYCSolutions') }}</swiper-slide>
                      <swiper-slide>{{ $t('Home.OwnershipPenetration') }}</swiper-slide>
                      <swiper-slide>{{ $t('Home.CompanyFinancialAnalysis') }}</swiper-slide>
                      <swiper-slide>{{ $t('Home.CreditRatings') }}</swiper-slide>
                      <swiper-slide>{{ $t('Home.CreditReports') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.ESGRatings') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.VendorScreening') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.MarketResearch') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.IndustryAnalysis') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.BusinessAnalytics') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.ImportExportData') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.CompanyNews') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.Sanctions') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.SearchLeads') }}</swiper-slide>

                      <!-- <swiper-slide>{{ $t('Home.BusinessIntelligence') }} </swiper-slide> -->
                      <swiper-slide>{{ $t('Home.CompanyIdentityVerification') }} </swiper-slide>
                      <swiper-slide>{{ $t('Home.KYCSolutions') }}</swiper-slide>
                      <swiper-slide>{{ $t('Home.OwnershipPenetration') }}</swiper-slide>
                      <swiper-slide>{{ $t('Home.CompanyFinancialAnalysis') }}</swiper-slide>
                      <swiper-slide>{{ $t('Home.CreditRatings') }}</swiper-slide>
                      <swiper-slide>{{ $t('Home.CreditReports') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.ESGRatings') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.VendorScreening') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.MarketResearch') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.IndustryAnalysis') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.BusinessAnalytics') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.ImportExportData') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.CompanyNews') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.Sanctions') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.SearchLeads') }}</swiper-slide>

                      <swiper-slide>{{ $t('Home.ImportExportData') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.CompanyNews') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.Sanctions') }}
                      </swiper-slide>
                      <swiper-slide>{{ $t('Home.SearchLeads') }}</swiper-slide>
                    </swiper>
                  </div>

                </div>


              </div>
              <div id="gea9ef" class="u5efe2" @click="gotccsibizinfo('https://www.csibizinfo.com/')">
                <img id="g78166" class="u326e0" src="../../assets/images/home_new_center.png" alt="" />
                <div id="g1e594" class="uc6717">
                  <div class="ud8c2c">
                    <!-- CSI, a data-driven research and IT firm, specializes in credit, risk, and big data. It offers digital tools to global investors and business professionals, leveraging advanced analytics and algorithms to provide fast, visual insights that facilitate smarter decision-making. -->
                    {{ $t('Home.homeTitleDetail') }}
                  </div>
                </div>
              </div>
              <div id="gf171a" class="u703ad">
                <div id="c2e2db" class="u4805e" style="margin-right: 0px;">
                  <div id="c4b663" class="uac3ec ua85bb">
                    <img id="c9c8d8" class="u2e0e9 u3eb4b" src="../../assets/img/WechatIMG290.jpg" alt="" />
                  </div>
                  <div id="c31866" class="">
                    <p class="last-book"> {{ $t('Home.phoneTitleDetail') }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Newsrecommendation></Newsrecommendation>

      </div>


    </div>
    <!-- 注释标记 -->
    <div id="c943c3" v-show="isShowChat" class="index_chart_gpt">
      <gui_chart id="gdf7da" @hide="hide($event)"> </gui_chart>
    </div>
    <Perfectdata :loginAndCreatePop.sync="Perfectdatalog"></Perfectdata>

    <Login :loginAndCreatePop.sync="loginDialog"></Login>
    <el-dialog :visible.sync="hasPrivilege" center :close-on-click-modal="true" @close="chasPrivilegeDialog"
      custom-class="dialog_normalsuo dialog_normalpower" :append-to-body="true">
      <div>
        <div class="detail_cont">
          <div class="flex_center">
            <img class="powerdengpao" src="@/assets/images/powerdengpao.png" alt="">
          </div>
          <div class="detail_cont_text">
            The feature you’re attempting to access is part of our premium membership benefits. To gain access to this
            feature and enjoy full access to premium features, please subscribe to our membership plan.
          </div>

        </div>
      </div>
      <div class="flex_center">
        <el-button class="btn_export btn_exportCCC" @click="hasPrivilege = false">OK</el-button>
        <el-button class="btn_export" @click="$router.push({
          path: '/index/addCredit',
        })">Subscribe</el-button>
      </div>
    </el-dialog>
    <OperationWarning></OperationWarning>

  </div>
  <!--srcviewshomeindexvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import { getqueryList, getNotificationList, markAllAsRead, getqueryaddList, getqueryremoveList, companyView } from "@/api/userApi";
import { LoginOut } from "@/api/api.js";
import bus from "../../components/bus";
import Login from "../../components/login.vue";
import Perfectdata from "../../components/PerfectData.vue";
import gui_card from "../../components/gui_card/gui_card.vue";
import { mixins1 } from "../../mixins/index";
import gui_chart from "../../components/gui_chart/gui_chart.vue";
import Hearder from "./header.vue";
import Newsrecommendation from "./Newsrecommendation.vue";
//importEnd
import { getCountryCollection, getUserSimpleInfo } from "@/api/companyApi.js";
import { searchCompany, productSearch, searchTradeHscode } from "@/api/searchApi.js";
import RouterDrawe from '../../components/router-drawer/drawer.vue'
import OperationWarning from "@/components/power/OperationWarning.vue";
import { mapGetters } from 'vuex'
export default {
  mixins: [mixins1],
  name: "",
  props: {

  },

  components: {
    Hearder,
    gui_chart,
    Login,
    gui_card,
    Perfectdata,
    RouterDrawe,
    OperationWarning,
    Newsrecommendation
  },
  created() {

    //登陆状态
    this.token ? (this.loginStatus = true) : (this.loginStatus = false);
    //登陆状态
    bus.$on("handleLogin", (loginCheck) => {

      // location.reload();
      this.loginStatus = loginCheck;
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.imageUrl = JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.userImg == null
        ? ""
        : 'https://www.csibizsearch.com/csi/usercenter/download/resource?resource=' + JSON.parse(localStorage.getItem("userInfo"))?.userInfo.userImg
      this.getUserSimpleInfoList()
      this.getqueryListDetale()
      this.getNotificationListDetali()


    });
    if (this.token) {
      this.companyViewPower()

      this.getUserSimpleInfoList()
      this.getqueryListDetale()
      this.getNotificationListDetali()
      this.imageUrl = JSON.parse(localStorage.getItem('userInfoImg')) == undefined ? this.imageUrl : JSON.parse(localStorage.getItem('userInfoImg'))
    }
  },
  mounted() {
    this.getAllCountry();
    this.selectLanguage({ countryCode: this.$store.state.app.lang })
    this.$i18n.locale = this.$store.state.app.lang
    this.$store.dispatch("app/setLang", this.$i18n.locale)
  },

  data() {
    return {
      Keyword: true,
      drawer: false,
      hasPrivilege: false,
      items: [1, 2, 3, 4, 5],
      activeIndex: 0,
      swiperOption: {
        slidesPerView: 10,
        centeredSlides: true,
        //居中幻灯片无缺口。当你通过设置 centeredSlides: true 使得幻灯片居中后，
        centeredSlidesBounds: true,
        normalizeSlideIndex: false,

        direction: 'vertical',
        spaceBetween: 0,
        // 滑动速度
        speed: 800,
        autoplay: { //自动开始
          delay: 3000, //时间间隔
          disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        // 无限循环
        loop: true,
        observer: false,
        observeParents: false,
      },
      Newlist: [],
      RedNews: [],
      ExpireDate: '',
      Vips: [],
      searchStr: "",
      AvailablePoints: 0,
      lockType: 0,
      percentage: 0,

      // isShowChannel
      isShowChannel: false,
      tradeSelect: 'HsCode',
      placeholder: "Enter company name",
      countryImg: "",
      tabCountryList: [],
      countryCode: '',
      countryCode1: '',
      countryName: "", //选中国家
      tabActiveName: "", //选择的区域
      placeholderTrade: "Search by",
      headPortrait: false,
      languageList: [
        {
          countryCode: 'en',
          countryCodeImg: 'GB',
          countryName: 'English',
          color: true

        },
        {
          countryCode: 'jp',
          countryCodeImg: 'JP',
          countryName: 'Japanese',
          color: false

        },
        {
          countryCode: 'de',
          countryCodeImg: 'DE',
          countryName: 'German',

        },
        {
          countryCode: 'fr',
          countryCodeImg: 'FR',
          countryName: 'France',

        },

        {
          countryCode: 'es',
          countryCodeImg: 'ES',
          countryName: 'Spain',

        },
        {
          countryCode: 'it',
          countryCodeImg: 'IT',
          countryName: 'Italy',

        },
        {
          countryCode: 'nl',
          countryCodeImg: 'NL',
          countryName: 'Netherlands',

        },
        {
          countryCode: 'pt',
          countryCodeImg: 'PT',
          countryName: 'Portugal',

        },


      ],
      // existingList
      existingList: [

      ],
      // paidList
      paidList: [

      ],
      // followingName
      followingName: "explore",
      // favoritesList
      favoritesList: [
        {
          name: "By letter",
          id: "blet",
          isActive: false,
        },
        {
          name: "By size",
          id: "bsz",
          isActive: false,
        },
        {
          name: "By category",
          id: "bct",
          isActive: true,
        },
        {
          name: "By date",
          id: "bd",
          isActive: false,
        },
        {
          name: "By status",
          id: "bst",
          isActive: false,
        },
      ],
      // activeFavoritesId
      activeFavoritesId: "",
      //
      isShowChat: false,
      loginDialog: false, //登录弹框
      loginStatus: false, //登录状态,
      Perfectdatalog: false, //收集信息
      userInfo: JSON.parse(localStorage.getItem("userInfo"))
        ? JSON.parse(localStorage.getItem("userInfo"))
        : null,
      token: localStorage.getItem("token"),
      userRole: {},
      percentageerr: false,

      moreclose: false,
      restaurants: [],
      state: '',
      timeout: null,
      imageUrl:
        JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.userImg == null
          ? ""
          : 'https://www.csibizsearch.com/csi/usercenter/download/resource?resource=' + JSON.parse(localStorage.getItem("userInfo"))?.userInfo.userImg,

      // srcviewshomeindexvueDataEnd
    };
  },

  methods: {
    selectLanguage(item) {
      this.languageList.map(ite => {
        if (ite.countryCode == item.countryCode) {
          ite.color = true
        } else {
          ite.color = false
        }
      })
      this.$i18n.locale = item.countryCode
      sessionStorage.setItem('language', this.$i18n.locale)

      this.$store.dispatch("app/setLang", this.$i18n.locale)

    },
    companyViewPower() {
      companyView({

      }).then(res => {
        if (!res.data) {
          this.$store.dispatch("app/SetOperationWarning", true)
          // this.$bus.$emit('show-OperationWaring-dialog', '');

        }
      })
    },
    OperationWarningShow() {
      this.$bus.$emit('show-OperationWaring-dialog', '');
    },
    // 九宫格
    clossuoDialog(value) {
      this.drawer = value
    },
    gotccsibizinfo(value) {
      window.open(value, '_blank')
    },
    // onSlideChange($event) {
    // },
    beforeEnter(el) {
      el.classList.add('active');
    },
    leave(el) {
      el.classList.remove('active');
    },
    labelClick(label) {
      this.countryName = label;

    },
    //清除选择的国家
    clearCountry() {
      this.countryImg = "";
      this.countryCode = "";
      this.countryCode1 = "";
    },
    selectCountry(val) {
      let countryImg = this.getCountryImgUrl(val);
      let flag = require("../../../static" + countryImg);
      this.countryImg = flag;
      this.countryCode = val;

      let newscountry = this.tabCountryList[0].countryList;
      newscountry.map((item) => {
        if (item.countryCode == val) {
          this.countryCode1 = item.dowjonesCountrycode;
        }
      });
    },
    //切换keyword
    switchHeadKeyword() {
      this.isKeyword != this.isKeyword
    },
    // 贸易模糊搜索
    querySearchAsync(queryString, cb) {
  
    //  this.$refs.TradeInput.suggestionVisible=false
      if (!this.loginStatus) {
        this.loginDialog = true
           cb([]);
      } else {
        if (queryString !== '') {
          if (this.tradeSelect == 'HsCode') {
            const params = {
              keyword: queryString,

            };
            productSearch(params)
              .then(res => {
                const data = res.data;
                if (res.code) {
                  data.forEach(item => {
                    item.val = item.hsCode;
                    item.value = item.hsCode + '-' + item.hsCodeDescription;

                    // item.val=item.value
                  });

                  cb(data);
                } else {
                  cb([]);
                }
              })
              .catch(() => {
                cb([]);
              });
          }
          if (this.tradeSelect == 'Company') {
            const params = {
              company_name: queryString,
              page: 1,
              pageSize: 100,
              ieflag: 1
            };
            searchCompany(params)
              .then(res => {
                const data = res.data;
                if (res.code) {
                  data.rows.forEach(item => {
                    item.val = item.aaa_id;
                    item.value = item.company_name_en;
                    // item.val=item.value
                  });
                  cb(data.rows);
                } else {
                  cb([]);
                }
              })
              .catch(() => {
                cb([]);
              });
          }
          if (this.tradeSelect == 'Country') {
            let Allcountry = JSON.parse(localStorage.getItem("countryList"))[0].countryList;
            Allcountry.forEach(item => {
              item.value = item.nameEn
              item.val = item.countryCode
            })
            let SelecrCountry = queryString ? Allcountry.filter(this.createStateFilter(queryString)) : Allcountry;
            cb(SelecrCountry);
          }


        }
      }

    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    // 选择贸易频道
    SelectTrade() {
      this.searchStr = ''
    },
    // 搜索下拉

    handleSelect(item) {
      let SACode1 = "";
      if (this.tradeSelect == 'Company') {
        sessionStorage.setItem("company", JSON.stringify(item));
        let newscountry = JSON.parse(localStorage.getItem("countryList"))[0].countryList;

        newscountry.map((ite) => {
          if (ite.countryCode == item.company_country) {
            SACode1 = ite.dowjonesCountrycode;
          }
        });
        let routeData = this.$router.resolve({
          // Tradecompany/Trade/
          // /company/detals
          path:
            "/index/tradeCompany/Trade/" +
            item.aaa_id +
            // "/background/snapshot?id3a=" +
            "/tradeMap/map?id3a=" +
            item.aaa_id +
            "&companyCountry=" +
            item.company_country +
            "&SACode1=" +
            SACode1 +
            "&companyName=" +
            item.company_name_en +
            "&Tradechannel=" + this.tradeSelect +
            "&Moudles=Trade",
        });
        window.open(routeData.href, "_blank");

      }
      if (this.tradeSelect == 'HsCode') {



        let routeData = this.$router.resolve({
          // Tradecompany/Trade/
          // /company/detals
          path:
            "/index/TradeProduct/TradeDetail/" +
            item.hsCode +
            // "/background/snapshot?id3a=" +
            "/tradeMap/map?id3a=" +
            item.hsCode +
            "&Tradechannel=" + this.tradeSelect +
            "&Moudles=Trade",
        });
        window.open(routeData.href, "_blank");

      } if (this.tradeSelect == 'Country') {

        let routeData = this.$router.resolve({
          // Tradecompany/Trade/
          // /company/detals
          path:
            "/index/TradeCountry/TradeDetail/" +
            item.countryCode +
            // "/background/snapshot?id3a=" +
            "/tradeMap/map?id3a=" +
            item.countryCode +
            "&Tradechannel=" + this.tradeSelect +
            "&Moudles=Trade",

        });
        window.open(routeData.href, "_blank");

      }

    },


    gotomessage(item) {
      this.$router.push({
        path: '/account/Notifications',
        query: {
          id: item.id
        }
      });
    },
    isShowChannelmethad() {
      this.isShowChannel = true
    },
    async getAllCountry() {
      let countryCode = ''
      // localStorage.setItem('countryList',JSON.stringify(countryImgList))
      // 处理缓存问题

      if (JSON.parse(localStorage.getItem("countryList"))) {
        this.tabCountryList = JSON.parse(localStorage.getItem("countryList"));
        let list = this.tabCountryList;
        list.forEach((item, index) => {
          item.countryList.forEach((it) => {
            let countryImg = "";
            if (it.urlBanner == null) {
              countryImg = "../../../static/imagev2/zanwutupian.png";
            } else {
              countryImg = it.urlBanner.split("../../../static")[1];
            }
            // let flag = require('../../static' + countryImg);
            let flag = "";
            try {
              flag = require("../../../static" + countryImg);
            } catch (error) {
              flag = "../../../static/imagev2/undefined.png";
              // 提供一个默认值或者其他处理方式
              // flag = require("../../../static" + countryImg);
            }
            it.urlBanner = flag;
            if (countryCode && it.countryCode == countryCode) {
              this.countryName = it.nameEn;
              this.countryImg = it.urlBanner;
            }
          });
        });
      } else {
        // 清理缓存后重新请求页面
        let res = await getCountryCollection();

        if (res && res.code) {
          let countryImgList = res.data.rows;
          this.$store.state.countryImgList = JSON.parse(
            localStorage.getItem("countryList")
          ); //res.data.rows
          this.tabCountryList =
            JSON.parse(localStorage.getItem("countryList")) == null
              ? res.data.rows
              : JSON.parse(localStorage.getItem("countryList"));

          localStorage.setItem("countryList", JSON.stringify(countryImgList));

          let list = this.tabCountryList;

          list.forEach((item, index) => {
            item.countryList.forEach((it) => {
              let countryImg = "";
              // /imagev2/zanwutupian.png
              if (it.urlBanner == null) {
                countryImg = "../../../static/imagev2/zanwutupian.png";
              } else {
                countryImg = it.urlBanner.split("../../../static")[1];
              }
              // let flag = require('../../static' + countryImg);
              let flag = "";
              try {
                flag = require("../../../static" + countryImg);
              } catch (error) {
                flag = require("../../../static/imagev2/undefined.png");
                // 提供一个默认值或者其他处理方式
                // flag = require("../../../static" + countryImg);
              }
              it.urlBanner = flag;
              if (countryCode && it.countryCode == countryCode) {
                this.countryName = it.nameEn;
                this.countryImg = it.urlBanner;
              }
            });
          });
        }
      }
    },
    AIseach() {
      if (this.loginStatus) {
        if (this.lockType == 2 || this.lockType == 3) {
          this.isShowChat = !this.isShowChat
        } else {
          this.hasPrivilege = true
        }
      } else {
        this.loginDialog = true
      }

    },
    chasPrivilegeDialog() {
      this.hasPrivilege = false
    },
    hide(value) {
      this.isShowChat = value

    },
    MarkRead() {
      markAllAsRead().then(res => {
        if (res.code == 200) {
          this.getNotificationListDetali()
          this.RedNews.length = 0
        }
      })
    },

    // 信息获取
    getNotificationListDetali() {
      getNotificationList().then(res => {
        if (res.code == 200) {
          this.Newlist = res.data
          if (this.Newlist.length > 0) {
            res.data.map(item => {
              if (item.hasRead == 0) {
                this.RedNews.push(item)

              }
            })
          }
        } else {
          this.Newlist = []
        }

      })
    },
    // 积分获取
    getUserSimpleInfoList() {
      getUserSimpleInfo().then(res => {
        if (res.code == 200) {
          if (res.data.certification != 1) {
            localStorage.setItem('renzheng', true)
          }
          this.AvailablePoints = res.data.availablePoints
          this.ExpireDate = res.data.expiration
          this.Vips = res.data.vips
          this.lockType = res.data.lockType
          this.$store.dispatch("app/setEquityType", res.data.availablePoints);

        }
      })

    },
    getqueryListDetale() {
      getqueryList().then(res => {
        if (res.code == 200) {
          let showList = []
          let showListtwo = []
          res.data.forEach(item => {
            showList.push({
              id: item.moduleId,
              name: item.screenName,
              type: item.screenName,
              isSelect: item.isShow,
              icon: item.icon
            })
            if (item.isShow == true) {
              showListtwo.push({
                id: item.moduleId,
                name: item.screenName,
                type: item.screenName,
                isSelect: item.isShow,
                icon: item.icon
              })
            }


          })
          this.existingList = showList

          this.paidList = showListtwo

        }
      })
    },


    gotoUSer(route) {
      this.$router.push({
        path: route,
      });
    },
    // insertMethod
    // srcviewshomeindexvueMethodStart
    // default
    Sign() {
      this.loginDialog = true;
    },

    default() { }, // 跳转搜索列表页面
    openList(str) {
      this.$store.dispatch("app/SetlabelCode", '');
      this.$store.dispatch("app/SetlabelCodeName", '');
      let Keyword = "";

      if (this.Keyword) {
        Keyword = 2;
      } else {
        Keyword = 1;
      }
      if (str) {
        this.$store.commit("setRefreshKey", new Date().getTime());
        this.$router.push({
          path: "/index/search/list/" + str + "/company",
          query: { searchname: str, companyCountry: this.countryCode, keword: Keyword },
        });
      } else {
        // this.$router.push({
        //   path: "index/list/company",
        // });
      }
    }, // deleteTool
    deleteTool(item) {
      let index = this.existingList.findIndex((item2) => item2.id == item.id);
      let paidListindex = this.paidList.findIndex((item3) => item3.id == item.id);

      this.existingList[index].isSelect = false


      if (index !== -1) {
        getqueryremoveList({
          moduleId: item.id
        }).then(res => {

        })
        this.paidList.splice(paidListindex, 1);
      }
      // item.isSelect = false;
    }, // addTool
    addTool(item) {

      let obj = this.existingList.find((item2) => item2.id == item.id);
      if (item.isSelect == false) {
        item.isSelect = true;
        getqueryaddList({
          moduleId: item.id
        }).then(res => {

        })
        this.paidList.push(JSON.parse(JSON.stringify(item)))
      }
    }, // taggleFlolwing
    taggleFlolwing(name) {
      this.followingName = name;
    },
    //Sign out 登出
    signOutAccount() {
      LoginOut({}).then((res) => {

        if (res.code == "200") {
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });

          bus.$off("handleLogin");
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          window.location.href = "/";
          localStorage.removeItem("userInfoImg");
          localStorage.removeItem("renzheng");
        } else {
          sessionStorage.clear();
          localStorage.removeItem("token");
          localStorage.removeItem("userInfoImg");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("renzheng");
          window.location.href = "/";
        }
      });
    },

    gotoOne(value) {
      window.open(value, '_blank')

    },
    goHome() {
      this.$router.push('/')
    },
    // srcviewshomeindexvueMethodEnd
  },

  computed: {
    ...mapGetters({
      lang: 'app/lang'
    }),
    classOption() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        // limitMoveNum: 10, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        // openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    },
  },
};
</script>
<style scoped>
.margin-left30 {
  margin-left: 2.1428rem;
}

.u3e56f {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0rem;
  left: 0rem;
  /* pointer-events:none; */
  z-index: -2;
}

.u090a2 {
  width: 100%;
  height: 100%;
}

.u070db {
  /* width: 50%;
  height: 50%; */
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  /* 不重复背景图 */
  background-position: center !important;
  /* 背景图居中显示 */
  background-repeat: no-repeat !important;
  /* 不重复背景图 */
  height: 100%;
  min-width: 137.14285714285714rem;
  background-size: cover !important;
  margin: 0;
  /* 去掉默认的 margin */
}

.u070db_1 {
  background: url("../../assets/images/chuan.png") no-repeat;
}

.u070db_2 {
  background: url("../../assets/images/0-3home.jpg") no-repeat;
}

.u070db_3 {
  background: url("../../assets/images/0-2Trame.jpg") no-repeat;

}

.u070db_4 {
  background: url("../../assets/images/0-5home.jpg") no-repeat;
}

.u070db_5 {
  background: url("../../assets/images/0-4home.jpg") no-repeat;
}



.u8c4dc {
  display: flex;

  height: 3.571rem;
  margin-top: 1.42857rem;
  margin-left: 1rem;
  margin-right: 2.85714286rem;
  align-items: center;
}

.u8220d {
  display: flex;
  align-items: center;

}

.u2042e {
  flex: auto;
}

.right_menu_box {

  margin-left: 2.1428rem;
  cursor: pointer;
}

.u0427c {
  display: flex;
  align-items: center;
  height: 2.428rem;
  padding-left: 0.714rem;
  padding-right: 0.714rem;
  padding-top: 0.21428571428571427rem;
  padding-bottom: 0.21428571428571427rem;
  box-sizing: border-box;
  border: 0.07142857142857142rem solid rgba(255, 255, 255, 0.5);
  border-radius: 1.142857rem;
}

.u84443 {
  margin-right: 0.45rem;
  color: #ffffff;
  font-size: 1.142857rem;
  text-align: center;
  line-height: 1.285rem;
  font-style: normal;
}

.ubbf89 {
  width: 1.571rem;
  height: 1.571rem;
  /* background-color: rgba(255, 255, 255, 1); */
  border-bottom-left-radius: 100rem;
  border-top-left-radius: 100rem;
  border-top-right-radius: 100rem;
  border-bottom-right-radius: 100rem;
  overflow-y: hidden;
  overflow-x: hidden;
}

.uf64b2 {
  /* margin-top: 1.42857em; */
  height: 2.8571rem;
  width: 3.714rem;
}

.u63509 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 164px;
  /* margin-top: 12.14285714rem; */
}

.u11f46 {
  display: flex;
  /* margin-top: 2.857142857142857rem;
  margin-bottom: 2.857142857142857rem; */
}

.u5faed {
  display: flex;
  align-items: center;
  width: 71.4285714rem;
  height: 5rem;
  padding-left: 1.4285714rem;
  box-shadow: 0rem 0.14285714285714285rem 0.714em 0rem rgba(42, 104, 142, 0.18);
  background: #ffffff;
  border-radius: 2.5rem;

}



.u0a08d {
  width: 0;
  flex: auto;
}

.u0fcfc {
  height: 2.1428rem;
  /* height: 2.142em; */
  margin-right: 0.5rem;
  flex: none;
  outline: none;
  border: none;
  box-shadow: none;
  font-size: 1.42857rem;
  color: #8497ab;
  line-height: 1.6428571428571428rem;
  text-align: left;
  font-style: normal;
}

.u44325 {
  width: 0.07142857142857142rem;
  height: 2.1428rem;
  /* margin-right: 0.714em; */
  background: #dddddd;
}

.u8146c {
  width: 8.571428rem;

  /* width: 90.42857em; */
  font-size: 1.142857rem;
  color: #8497ab;
  line-height: 1.2857142857142858rem;
  text-align: center;
  font-style: normal;
}

.u4a33a {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10.86714rem;

  height: 100%;
  background: #1290c9;

  border-radius: 0rem 7.143rem 7.143rem 0rem;
  position: relative;
  left: 0.07142857142857142rem;
}

.u4a33a span {
  color: #ffffff;
  font-size: 1.2857143rem;
}

.u0ecfc {

  display: flex;
  position: relative;
  width: 55rem;
  height: 5rem;
  justify-content: space-between;
}

.u270ed {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* margin-right: 0.5em;
  margin-left: 0.5em; */
  cursor: pointer;
}

.u99787 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3.2142857142857144rem;
  height: 3.2142857142857144rem;
  box-shadow: 0rem 0.07142857142857142rem 0.42857142857142855rem 0rem rgba(42, 104, 142, 0.2);
  margin-bottom: 0.714rem;
  background: #ffffff;
  border-radius: 0.857rem;
}

.u74fe0 {
  font-size: 1rem;
  color: #ffffff;
  line-height: 1.142857rem;
}

.ufb774 {
  position: absolute;
  top: 3.857142857142857rem;
  left: -6.785714285714286rem;
  z-index: 15;
}

.u152b4 {
  width: 70rem;
  height: 37.285714285714285rem;
  padding: 1.42857rem;
  /* padding-left: 20.5em;
  padding-right: 20.5em;
  padding-top: 10.5em;
  padding-bottom: 10.5em; */
  background: #ffffff;
  box-shadow: 0rem 0.07142857142857142rem 0.42857142857142855rem 0rem rgba(42, 104, 142, 0.2);
  border-radius: 0.857rem;
}

.u0edc3 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.42857rem;
  line-height: 1.42857rem;
  height: 1.42857rem;
}

.uc5ba9 {
  font-size: 1.42857rem;
  color: #1a2332;
  line-height: 1.42857rem;
  text-align: left;
  font-style: normal;
  font-weight: normal;
}

.u6db8d {
  display: flex;
  padding-bottom: 1.42857rem;
  width: 55rem;
  justify-content: space-between;
}

.ua1da6 {
  color: rgba(8, 8, 8, 1);
}

.u5e514 {
  height: 0.07142857142857142rem;
  background: #dddddd;
}

.ud0e75 {
  padding-top: 1.42857rem;
  padding-bottom: 0.714rem;
}

.u8d45c {
  color: #1290c9;
  font-size: 1.142857rem;
  margin-bottom: 0.714rem;
  font-weight: normal;
  text-align: left;
  line-height: 0.857rem;
  font-style: normal;
  margin-top: 0.42857rem;
}

.u47dc6 {
  display: flex;
  flex-wrap: wrap;
}

.u1aaaf {
  display: flex;
  align-items: center;
  height: 2.4285714285714284rem;
  margin-right: 1.0714285714285714rem;
  padding-left: 0.714em;
  padding-right: 0.714em;
  padding-top: 0.6428571428571429rem;
  padding-bottom: 0.6428571428571429rem;
  margin-bottom: 1em;
  background: #f5f5f5;
  border-radius: 0.2857142857142857rem;
}

.u4646c {
  margin-right: 0.21428571428571427rem;
}

.ukBgk9n {
  margin-right: 1.42857rem;
  color: #1a2332;
  font-size: 1.142857rem;
  text-align: left;
  line-height: 0.857rem;
  font-style: normal;
}

.ufd6a8 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.42857rem;
  height: 1.42857rem;
  border-bottom-left-radius: 100rem;
  border-top-left-radius: 100rem;
  border-top-right-radius: 100rem;
  border-bottom-right-radius: 100rem;
  /* margin-left: 0.5em; */
  background: #ffffff;
}

.ubb80e {
  /* width: 82.7%;
 
  position: absolute;
  bottom: 0rem; */
  /* 首页底部 */
  width: 82.7%;
  margin-top: 53px;
  position: fixed;
  bottom: 4.8714285rem;

}

.u1df9f {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 97.5%;
  height: 6.285rem;
  padding-left: 1.428rem;
  padding-right: 1.428rem;
  background: #363f46;
  border-radius: 0.42857rem;
  backdrop-filter: blur(0.5714285714285714rem);
  margin-left: 1.428rem;
  margin-right: 1.428rem;
  background-color: rgba(54, 63, 70, 0.42);
}

.u2772e {
  font-size: 2.4285rem;
  color: #ffffff;
  line-height: 3.214rem;
  text-shadow: 0rem 0.14285714285714285rem 0.14285714285714285rem rgba(6, 59, 64, 0.5);
  text-align: left;
  font-style: normal;
  font-family: "DMSans DMSans" !important;
}

.ua06ec {
  font-size: 1.2857rem;
  color: #ffffff;
  line-height: 1.5rem;
  text-align: right;
  font-style: normal;
  font-family: "DMSans DMSans" !important;
}

.u9a1a8 {
  padding: 1.428rem;
  background: #ffffff;
  border-radius: 0.857rem 0.857rem;
  /* padding-bottom: 0rem; */
}

.ued8bb {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.857rem;
  display: none;
}

.u807e8 {
  display: flex;
  align-items: center;
  padding-left: 1.42857rem;
  padding-right: 1.42857rrem;
  padding-top: 0.714rem;
  padding-bottom: 0.714rem;
  background: #ffffff;
  border-radius: 0.857rem;
  font-size: 1.2857142857142858rem;
  color: #ffffff;
  line-height: 1.5rem;
  text-align: right;
  font-style: normal;
  border: 0.07142857142857142rem solid #dddddd;
}

.u476e8 {
  font-size: 1.142857rem;
  color: rgba(0, 0, 0, 1);
  line-height: 0.857rem;
  text-align: center;
  font-style: normal;
  margin-right: 1.7142857142857142rem;
}

.u6eb8b {
  color: rgba(1, 1, 1, 1);
}

.home_news_down {
  display: flex;
  align-items: center;
  height: 3rem;
  background: #ffffff;
  border: 0.07142857142857142rem solid #dddddd;
  border-radius: 0.7857142857142857rem;
}

.unrH9VJ {
  font-size: 1.142857rem;
  color: #000000;
  line-height: 0.857rem;
  text-align: left;
  font-style: normal;
  margin-right: 1.42857rem;
}

.u606de {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: none;
  padding: 0.714em 0rem;
  font-size: 1.2857143rem !important;

}

.u7fb7a {
  width: 1em;
  margin-right: 0.5rem;
}

.ucc8d2 {
  color: rgba(26, 35, 50, 1);
  font-size: 1.142857rem;
}

.u75237 {
  display: flex;
  height: 22.328rem;
}

.u5efe2 {
  width: 38.41%;
  height: 100%;
  background: #eeeeee;
  border-radius: 0.857rem 0.857rem 0rem 0rem;
  position: relative;
  margin-right: 1rem;
  cursor: pointer;

}

.u326e0 {
  width: 100%;
  height: 100%;
  border-radius: 0.857rem;
}

.uc6717 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-left: 1.428rem;
  padding-right: 1.428rem;
  padding-top: 0.714rem;
  padding-bottom: 0px;
  position: relative;
  /* background: linear-gradient(180deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(3, 3, 3, 0.56) 100%); */
  border-radius: 0.857rem;
  overflow: hidden;
  position: absolute;
  left: 0rem;
  flex-direction: column;
  z-index: 10;
  bottom: 0rem;
}

.uc9f98 {
  font-family: "DMSans DMSans";
  font-weight: bold;
  font-size: 1.714rem;
  color: #FFFFFF;
  /* line-height: 2.4285714285714284rem; */
  text-shadow: 0rem 0.14285714285714285rem 0.14285714285714285rem rgba(0, 0, 0, 0.1);
  text-align: justify;
  font-style: normal;


}

.ud8c2c {
  position: absolute;
  bottom: 1.42857143rem;
  padding: 0px 20px;
  font-family: "DMSans DMSans";
  font-size: 1.2857143rem;
  color: #FFFFFF;
  /* line-height: 27px; */
  opacity: 0.9;
  text-shadow: 0rem 0.14285714285714285rem 0.14285714285714285rem rgba(0, 0, 0, 0.8);
  text-align: left;
  font-style: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  overflow: hidden;
  text-overflow: ellipsis;
}

.u703ad {
  display: flex;
  width: 0;
  flex: auto;
}

.u4805e {
  display: flex;
  width: 0;
  height: 100%;
  background: #eeeeee;
  border-radius: 0.857rem 0.857rem;
  flex-direction: column;
  flex: auto;
  margin-right: 0.5rem;
}

.uac3ec {
  height: 12rem;
}

.u2e0e9 {
  width: 100%;
  height: 100%;
}

.u714d2 {
  height: 0;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.714rem;
  padding-bottom: 0.714rem;
  flex: auto;
}

.u97f5f {
  margin-bottom: 0.42857rem;
  font-size: 12px;
  color: #666666;
  line-height: 1.142857rem;
  text-align: left;
  font-style: normal;
}

.u714d2 p {
  font-family: "DMSans DMSans";
  /* font-weight: bold; */
  font-size: 14px;
  color: #000000;
}

.u42764 {
  margin: 0.714rem 0rem;
  font-weight: normal;
  font-family: "DMSans DMSans";
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  line-height: 1.2857rem;
  text-align: left;
  font-style: normal;
  /* 最大高度为两行的高度 */
}

.max2clamp {
  display: -webkit-box;
  /* 使用 flexbox 布局 */
  -webkit-box-orient: vertical;
  /* 垂直排列 */
  -webkit-line-clamp: 2;
  /* 限制为两行 */
  overflow: hidden;
  /* 隐藏超出部分 */
  text-overflow: ellipsis;
  /* 使用省略号 */

  max-height: 5rem;
}

.ua85bb {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 0.714rem;
}

.u3eb4b {
  width: 8.57rem;
  height: 8.57rem;
}

.ubab9d {
  margin-bottom: 0.42857rem;
  text-align: center;
}

.u6ec5c {
  text-align: center;
  font-size: 12px;
  color: #999999;
  line-height: 1rem;
}

.index_chart_gpt {
  width: 42.8571429rem;
  /* height: calc(100% - 6.5rem); */
  min-height: 50rem;
  position: fixed;
  right: 0rem;
  top: 0rem;
  background: #ffffff;
  z-index: 999999;
}

.u0fcfc input {
  padding-left: 0.5rem;
  padding-top: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 0.5rem;
  border-style: none;
}

.u6db8d .u270ed {
  margin-right: 1.42857rem;
}

.u6db8d .u74fe0 {
  color: rgba(8, 8, 8, 1);
}

.u47dc6 .active {
  border: 0.07142857142857142rem solid #1290c9;
}

.u47dc6 .active {
  border: 0.07142857142857142rem solid #1290c9;
}

.u807e8 .active {
  color: rgba(18, 144, 201, 1);
}

.u606de .active {
  color: rgba(18, 144, 201, 1);
  fill: #1290c9;
}

/* 登陆 */
/* 菜单 */
.head_menu_box {
  width: 100%;
  height: 3.571em;
  background: #fff;
  box-shadow: 0rem 0.14285714285714285rem 0.42857142857142855rem 0.07142857142857142rem rgba(10, 33, 57, 0.14);
}

.head_menu_list {
  display: flex;
  justify-content: center;
}

.head_menu_list /deep/ .el-radio-button__inner {
  padding: 1.1428571428571428rem 0rem 0.857em;
}

.head_menu_list /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #1290c9;
  background-color: #fff;
  border-color: #1290c9;
  box-shadow: none;
}

.head_menu_item /deep/ .el-radio-button__inner {
  border: none;
  border-bottom: 0.14285714285714285rem solid transparent;
  border-radius: 0;
  line-height: 1.2857142857142858rem;
  font-size: 1rem;
  color: #022955;
}

.head_menu_item {
  line-height: 1.42857rem;
  font-size: 1rem;
  /* padding: 1.2857142857142858rem2.1428em 0.714em2.1428em; */
  text-align: center;
  /* margin: 02.1428em; */
  padding: 02.1428rem;
}

.search_option /deep/ .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
  box-shadow: none !important;
}

.top_usage {
  padding: 1.0714285714285714rem 0.714rem;
  background: #f2f5f9;
  border-radius: 1rem;
  margin-bottom: 0.5rem;
}

.usage_prog {
  flex: 1;
}

.usage_ic {
  width: 20.42857rem;
  height: 20.42857rem;
  line-height: 20.42857rem;
  /* background: #ffffff; */
  border-radius: 50%;
  margin-right: 0.714rem;
  text-align: center;
  background-color: rgb(0, 49, 7);
}

.usage_ic img {
  width: 0.857rem;
  height: 0.857rem;
}

.usage_icone {
  background: #ffffff !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.usage_icone img {
  width: 1.142857rem;
  height: 1.142857rem;
}

.usage_txt {
  font-size: 1rem;
  color: #022955;
  margin-bottom: 0.5714285714285714rem;
}

.usage_total {
  font-size: 0.857rem;
  color: #8497ab;
}

.usage_used {
  margin-top: 0.5714285714285714rem;
  font-size: 0.857rem;
  color: #1290c9;
}

.acc_signout,
.top_acc_menu_box li a {
  display: block;
  padding: 0.5714285714285714rem 0.714rem;
  font-size: 1rem;
  color: #022955;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.acc_signout:hover,
.top_acc_menu_box li a:hover,
.top_acc_menu a.router-link-exact-active.router-link-active {
  color: #1290c9;
}

.acc_signout:hover,
.top_acc_menu_box li a:hover {
  background: #ebf2ff;
  border-radius: 1rem;
}

.head_login,
.acc_signout {
  cursor: pointer;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3.5714285714285716rem !important;
  background-color: #fff;
  margin: auto;
  padding: 0;
}

.head_sign {
  cursor: pointer;
  color: #022955;
  line-height: 3.571rem;
}

.head_top_left {
  width: 11.571428571428571rem;
  height: 20.42857rem;
  cursor: pointer;
}

.switch_txt {
  font-size: 1rem;
  color: #ffffff;
  /* line-height: 1.142857rem; */
}



/deep/ .el-dropdown-menu__item {
  font-size: 1.42857rem !important;
  color: #1a2332;
}

/deep/ .el-badge__content {

  min-height: 1rem;
  min-width: 1.2857142857142858rem;
  border-radius: 50%;
  padding: 0rem;
}

/deep/ .el-badge__content--warning {
  background-color: #F56C6C;
  top: 1.2142857142857142rem !important;
  right: -0.35714285714285715rem !important;
  width: 1.42857rem;
  height: 1.42857rem;
  border-radius: 50%;
  font-size: 0.857rem;
  line-height: 1.42857rem;
}

.history_box-headborder {
  border-bottom: 0.07142857142857142rem solid #DDDDDD;
  padding-bottom: 0.714rem;


}

.history_box-head {
  font-size: 1.42857rem;
}

.history_box {
  height: 21.428rem;
  overflow-y: auto;
  padding-bottom: 2.857142857142857rem;
}

.item_title {
  padding: 1.4285714285714286rem 0rem;
  /* background-color: #f5f5f5; */
  /* margin-bottom: 0.714em; */
  border-bottom: 0.07142857142857142rem solid #dddddd;
}

.messageimg {
  height: 2.857142857142857rem;
  width: 2.857142857142857rem;
  border-radius: 50%;
}

.item_cont_txt {
  padding: 0.714em;
  border-radius: 0.42857rem;
  font-size: 1.142857rem;
  color: #1a2332;
  background-color: #f5f5f5;
  margin-top: 1rem;
}

.head-text {
  font-family: 'DMSans Bold';
  font-size: 1.2857142857142858rem !important;
  text-align: left;
  font-style: normal;
  color: #1a2332;
  line-height: 1.42857rem;
}

.icon {
  /* margin-right: 0.714em; */
}

.icon-time {
  font-size: 1rem;
  line-height: 1.6428571428571428rem;
  color: #999999;
  margin-top: 0.5714285714285714rem;
}

.message-right {
  margin-left: 1.42857rem;
}

.history_box_bottom {
  position: absolute;
  bottom: 0rem;
  padding-top: 1rem;
  background: #ffffff;
  width: 100%;
  border-top: 0.07142857142857142rem solid #dddddd;
}

.right-blue {
  margin-top: 0.5rem;
  width: 0.714rem;
  height: 0.714rem;
  background: #F56C6C;
  border-radius: 50%;
  padding-left: 0.714rem;
}

.srcviewslayoutheadervuecssEnd {}

.icontwo {
  margin-right: 0.714rem;
}

.postiverelatibve {
  position: relative;
}







.postiveaboust {
  position: absolute;
  right: -1em;
  top: 2.7857142857142856rem;
}

.avatar {
  width: 3.4285rem;
  ;
  height: 3.4285rem;
  ;
  border-radius: 50%;
  display: block;
  background: #f5f5f5;
  /* font-size: 2.857rem; */
  font-size: 2.28571429rem;
  line-height: 3.4285rem;
  text-align: center;
  color: #a2a9b0;
  overflow: hidden;
}

.avatarnologin {
  height: 3.4285rem;
  ;
  width: 3.4285rem;
  ;
  border-radius: 50%;
  display: block;
  background: #f5f5f5;
  line-height: 3.4285rem;
  ;
  text-align: center;
  color: #a2a9b0;
  /* overflow: hidden; */
}

.avatarnologin_1 {
  font-size: 2.157rem;
}

.account-left-right {
  margin-left: 1.5714285714285714rem;
}

.account-left-right h3 {
  font-size: 1.2857143em;
  color: #1a2332;
  line-height: 1.7142857142857142rem;
}

.account-left {
  margin-bottom: 2.1428em;
}

.account-left-right h4 {
  font-size: 1.142857rem;
  color: #666666;
  margin-top: 0.42857rem;
}

.progress {
  margin-top: 1.42857em;
  margin-bottom: 0.714em;
}

.ExpireDate {
  font-size: 14px !important;
  color: #8497AB;
  line-height: 1.142857em;
  /* padding-bottom: 1.42857em; */
}

.ExpireDate :nth-of-type(1) {
  border-bottom: 0.07142857142857142rem solid #dddddd;

}

.Available {
  font-size: 1.2857142857142858rem;
  color: #1a2332;
  margin-top: 1.142857em;
  margin-bottom: 1.42857em;
}

.henggang {
  height: 0.07142857142857142rem;
  margin: 0.21428571428571427rem 1.42857em;
  background-color: #dddddd;
}

.u1ba31 {
  width: 3.571em;
  height: 3.571em;
  overflow: hidden;
  border-radius: 50%;
}

.uc68vlP {
  margin-right: 1.142857em;
}

.flex_box {
  position: relative;
}

.right-blue {
  position: absolute;
  right: 0rem;
}


#g063ad {
  /* height: 2.425714rem; */
  height: 32px;
  cursor: pointer;
}

#cfab98 {
  height: 2.857142857142857rem;
}

.icon {
  /* height: 20.42857em; */
}

/deep/ .el-input__inner {
  padding-left: 0.714rem;
  line-height: 100%;
  font-size: 1.285714rem;
}

/deep/ .el-input__inner::placeholder {
  color: #8497AB;
  /* 更改为您想要的颜色 */
  opacity: 1;
  /* 确保不透明度为 1 */
}

.activecolor {
  color: #1290c9;
}

.Seach_text {
  margin-top: 2.1428714rem;
  font-family: "DMSans DMSans";
  height: 2.1428rem;
  line-height: 2.1428rem;
  font-size: 1.2857143rem;
  color: #FFFFFF;
  text-shadow: 0rem 0.14285714285714285rem 0.14285714285714285rem rgba(0, 0, 0, 0.3);
  text-align: center;
  font-style: normal;
  opacity: 0.8;
}

.last-book {
  text-align: center;
  margin-bottom: 0.714em;
  margin-top: 0.5rem;
  font-size: 1.2857143rem;
}

/deep/ .el-carousel__indicators--horizontal {
  bottom: 0.5rem;
  width: 5.714285714285714rem;
  left: 52%;
}

/deep/ .el-carousel__indicator .el-carousel__button {
  height: 0.5714285714285714rem;
  outline: 0;
  width: 0.5714285714285714rem;
  border-radius: 50%;
}

#c31866 {
  padding: 0 0.714em;
}

.fontDsamBold {
  font-family: 'DMSans Bold' !important;
}

.u9qMull {
  display: inline-block;
  width: 100%;
}

/* /deep/ #c308fb{
  padding-left: 2.0rem !important;
} */
/deep/ .el-input-group__prepend {
  width: 132px;
  background-color: #FFFFFF;
  color: #1A2332;
  border-right: 1px solid #DDDDDD;
}

/deep/ .el-input-group--prepend .el-select .el-input__inner {
  font-size: 1.28571428571428rem;
  padding-right: 2.5rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

}

/deep/ .el-input-group--prepend .el-input__suffix {
  right: 0px;
}

/* 国家搜索 */
.country_flag {
  display: flex;
  align-items: center;
  height: 2.142857142857143rem;
  width: 3.142857142857143rem
}

.country_flag_img {
  width: 2.7142857142857144rem;
  height: 1.5714285714285714rem;
  margin: 1.0714285714285714rem 0.14285714285714285rem 1.0714285714285714rem 0rem;
  box-shadow: 0rem 0.07142857142857142rem 0.14285714285714285rem 0rem rgba(0, 0, 0, 0.2);
}

.sel_value {
  width: 4.571428571428571rem;
  font-size: 1rem;
  word-break: break-all;
}

/* 选择下拉 */
.search_left {
  width: 10.028571428571429rem;
  height: 2.142857142857143rem;
  /* height: 100%; */
  position: relative;
  display: flex;
  align-items: center;
}

.search_left::after {
  content: "";
  position: absolute;
  right: 0.21428571428571427rem;
  top: 0em;
  width: 0.07142857142857142rem;
  height: 2.142857142857143rem;
  background-color: #dddddd;
}


.search_left .el-select {
  position: absolute;
  /* top: 0; */
  width: 10.285714285714286rem;
}

.search_left /deep/ .el-select .el-input__inner {
  background-color: transparent;
  /* height: 3.7142857142857144em; */
  /* opacity: 0; */
  font-size: 1rem;
  white-space: nowrap;
  padding-left: 0rem !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

.search_left.on /deep/ .el-select .el-input__inner {
  padding-left: 3rem !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.head_pro_cas /deep/ .el-input__inner::placeholder,
.search_left /deep/ .el-select .el-input__inner::placeholder {
  color: #022955;
}

.head_pro_cas /deep/ .el-icon-arrow-down:before,
.search_left /deep/ .el-select .el-icon-arrow-up:before {
  color: #8497ab !important;
  /* font-weight: 600; */
}

.search_sel_container /deep/ .el-tabs__active-bar {
  display: none;
}

.search_sel_container .right {
  width: 68.5rem;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  max-height: 24.285714285714285rem;
  align-content: flex-start;
  margin-right: 0.07142857142857142rem;
  padding: 0 0.571428571428571rem;
  overflow: auto;
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__item.is-left {
  height: 3rem;
  /* line-height: 3rem; */
  margin-bottom: 0.5714285714285714rem;
  padding: 0 0.7142857142857143rem !important;
  display: flex;
  align-items: center;
}

.search_sel_container /deep/ .el-tabs__item.is-left.is-active {
  background: #F5F5F5;
}

.el-select-dropdown__item:hover {
  background: #F5F5F5;
}

.search_sel_container /deep/ .el-tabs__item:hover {
  color: #1290c9;
  font-weight: normal;
}

.search_sel_container .left_txt {
  font-size: 1.1428571428571428rem;
  margin-right: 10px;
}



.search_sel_container .right .el-select-dropdown__item {
  width: 15.857142857142858rem;
  height: 4rem;
  padding: 0 0.7142857142857143rem;
  margin: 0.3542857142857143rem 0.35714285714285715rem;
  border: 0.07142857142857142rem solid #fff;
  background: #F5F5F5
}

.search_sel_container .right /deep/ .el-select-dropdown__item.selected,
.search_sel_container .right /deep/ .el-select-dropdown__item.hover {
  background: #F5F5F5;
  /* border-radius: 1rem; */
  border: 1px solid #1290c9;
}

.search_sel_container .right /deep/ .el-select-dropdown__item.selected {
  color: #022955;
  font-weight: normal;
}

.right_item {
  height: 100%;
  width: 100%;
}

.search_sel_container .right .img {
  width: 3.857142857142857rem;
  height: 100%;
  margin-right: 0.35714285714285715rem;
}



.search_sel_container .right .rBox {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.search_sel_container .right .rBox .coun_title {
  font-size: 1.142857rem;
  line-height: 1;
  margin-bottom: 0.2857142857142857rem;
  max-width: 10rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}


.search_left /deep/ .el-select .el-input__inner {
  border: none;
  font-size: 1.28571428571428rem;

}

/* .u070db,
/deep/ .el-carousel__item {
  opacity: 0.4;


  transition: opacity 2s ease, ;
}

.u070db.active,
.is-active,
/deep/ .is-active {
  opacity: 1 !important;
} */

.seamless-warp {
  overflow: hidden;
  width: 100%;
  color: white;
  font-size: 18px;
  text-align: center;

}

.timeline {
  height: 80%;

}

.botton_left_text {
  background: #1290C9;
  border-radius: 12px 12px;
  height: 100%;
  width: 100%;
  padding-left: 2.428rem;
}

/deep/.swiper-container {
  height: 21.4285714rem;
}

.slide-text {
  text-align: center;
  font-size: 1.14285714rem;
  color: #666;
  transition: all 0.3s;
}

/deep/ .swiper-slide {
  width: 100% !important;
  text-align: left !important;
  height: 2.14285714rem !important;
  font-size: 1.2857143rem;
  line-height: 2.14285714rem;
  transition: transform 0.3s, color 0.3s;
  padding-left: 5px;
  color: #F4F4F44D;
  transition: 0.5s ease-in-out !important;
  font-family: "DMSans DMSans";
}

/deep/.swiper-slide-active {
  color: #F4F4F4 !important;
  font-size: 1.714285714rem !important;
  font-family: 'DMSans Bold';
}

.shuidi {
  position: relative;
  left: -24px;
  top: 11.46rem;
}

.NewsBack {
  background-color: #009EA7 !important;

}

.RiskBack {
  background-color: #1290c9 !important;
}

@media (max-width: 1440px) {
  .u5faed {
    width: 666px;
    height: 46px;
    border-radius: 24px;
  }

  .u4a33a {
    width: 102px !important;
  }

  .u4a33a span,
  .Seach_text,
  /deep/ .el-input__inner {
    font-size: 14px !important;
  }

  .u63509 {
    margin-top: 144px;
  }
}


/* 穿透样式 */
/* /deep/ .swiper-slide-active {
  transform: scale(1.2); /* 可选动画增强效果 */
/* }  */

/*cssStart*/

/*cssEnd*/
</style>